import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Contrast } from "../../../types/general.types";
import { Icon } from "../..";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import StyledButton from "./IconButton.style";
import { IconButtonVariants, IconButtonWeights, } from "./constants";
const IconButton = ({ onClick = () => { }, onMouseOver = () => { }, onMouseLeave = () => { }, isDisabled = false, variant = IconButtonVariants.primary, contrast = Contrast.default, weight = IconButtonWeights.medium, iconName = "", className = "", ...props }) => {
    const [onHover, setOnHover] = useState(false);
    const internalOnMouseLeave = () => {
        setOnHover(false);
        onMouseLeave;
    };
    const getIconProps = (variant, isDisabled, weight, contrast) => {
        const iconProps = {
            size: weight === IconButtonWeights.medium
                ? IconSizes.medium
                : IconSizes.small,
            isColorVariant: onHover,
            contrast: contrast,
        };
        switch (variant) {
            case IconButtonVariants.neutral: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    isDisabled: isDisabled,
                };
            }
            case IconButtonVariants.primary: {
                return {
                    ...iconProps,
                    variant: IconVariants.primary,
                    isDisabled: isDisabled,
                };
            }
            case IconButtonVariants.secondary: {
                return {
                    ...iconProps,
                    variant: IconVariants.secondary,
                    isDisabled: isDisabled,
                };
            }
        }
    };
    return (_jsx(StyledButton, { onClick: onClick, onMouseOver: onMouseOver, onMouseEnter: () => setOnHover(true), onMouseLeave: internalOnMouseLeave, isDisabled: isDisabled, variant: variant, contrast: contrast, className: className, ...props, children: iconName && (_jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, weight, contrast) })) }));
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map